
import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import axios from 'axios';
import Signup from './Signup';
import Configdata from './Defaultdata';
import {checauthu,getanroidpin,connect} from './Androidconnet';

import {isvalidatemail,isvalidmob,isvaluenull,isvaliduser,isequal} from './validation';
import { getmessage,wrongmsg,getusertype,searchpostnow,clearform,gtlclstor } from './Dynamictable';
import { cityidfromcod,gets,authuloged,loadwidgate } from './userdefaultdata';
import Usersession from './Usersession';
import Forgotpassword from './Forgotpassword'
import {unmountComponentAtNode} from 'react-dom';
import Home from './Home';

class Registerpin extends Component {
	constructor(props: any) {
   	super(props);
	this.state.togglesineup = false;
    	this.state.ltypeguest = false;

  	}
	state = {
        name: "",
	email:"",
	paswrd:"",
	mlorph:"",
        togglecrit: false,
        togglesineup:false,
	slcttype:false,
	ltypeguest:false,
	iscode:true,
	rcname:"",
	scode:"",

    	};

	guestlogindivshow(){
		this.setState({ ltypeguest: true });
		this.displayenrtryname(1);
		this.displayenrtryemail(1);
		this.displayenrtrypass(0);

	}
        logindivshow(){

         	 this.setState({ slcttype: true });
		this.setState({ ltypeguest: false });
		this.displayenrtryname(1);
		this.displayenrtryemail(1);
		this.displayenrtrypass(0);
		
	}
	typeselect(e: any){
		
		this.desecttypes();
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';

		//alert(eid);
		if(eid == 'loginguestdiv')
		{
		 this.guestlogindivshow();
		
		}
		else if(eid == 'loginuserdiv'){
		this.logindivshow();
		//this.setState({ slcttype: true });
		//this.setState({ ltypeguest: false });
		//this.displayenrtryname(0);
		//this.displayenrtryemail(1);
		//this.displayenrtrypass(1);
		
		}
		else if(eid == 'searchlease'){
		this.setState({ slcttype: true });
		
		}
		else if(eid == 'searchservice'){
		this.setState({ slcttype: true });
		}

		e.preventDefault()

	};
	usersineup(e: any){
	   try {
		
		const signups = <Signup />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(signups,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   }
	    catch(e){
		
	     }	
	     e.preventDefault()

	};
	forgotpswd(e: any){
	   try {
		
		
                var maindiv = document.getElementById('upassdiv') as HTMLElement;
		const Pdivr = document.getElementById('recoverypass') as HTMLElement;
		
		maindiv.style.display = 'none';
		Pdivr.style.display = 'block';
                this.setState({ iscode: false });

	     
	   }
	    catch(e){
		
	     }	
	     e.preventDefault()

	};
      closelogin(e: any){
	   try {
		
		
                var maindiv = document.getElementById('sinupsidebardiv') as HTMLElement;
		
		maindiv.style.display = 'none';
		this.setState({ iscode: true });
	   }
	    catch(e){
		
	     }	
	     e.preventDefault()

	};

	iregctrlsvalidate(tp: any){
	 let isvalid = true;
	 let mailorphone = false;	
		if(isvalidatemail(this.state.email)){
			 mailorphone = true;
			 this.setState({ mlorph: 'mail' });
		}
		 if(isvalidmob(this.state.email)){
			 mailorphone = true;
			this.setState({ mlorph: 'ph' });
		}
		if(mailorphone != true) {
		getmessage('Please enter a valid email or phone no.','');
	  	return false;

		}
		if(tp == 'autho'){
		if(isvaluenull(this.state.paswrd)){
		 getmessage('password should not blank','');
	  	return false;
		}
		}	
	return isvalid;
	}
	

	desecttypes(){
		this.setState({ slcttype: false });
		const gstuser = document.getElementById('loginguestdiv') as HTMLElement;
		const logonuser = document.getElementById('loginuserdiv') as HTMLElement;
		gstuser.style.backgroundColor = 'gray';
		logonuser.style.backgroundColor = 'gray';

		
	}
	displayenrtryname(d: any){
	const unamedv = document.getElementById('unamediv') as HTMLElement;

	 if(d == 0) unamedv.style.display = 'none';
	 else 	unamedv.style.display = 'block';

	}
	displayenrtryemail(d: any){
	const umail = document.getElementById('uemailodiv') as HTMLElement;

	 if(d == 0) umail.style.display = 'none';
	 else 	umail.style.display = 'block';

	}
	displayenrtrypass(d: any){
	const upass = document.getElementById('upassdiv') as HTMLElement;

	 if(d == 0) upass.style.display = 'none';
	 else 	upass.style.display = 'block';

	}


	componentDidMount() {
        //debugger;
	
     	 //this.guestlogindivshow();
	this.logindivshow();
       this.setState({ iscode: true });

     
    	}

	textboxChange(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	//alert(id);
        if(id == 'txtusername'){
        
	 this.setState({ name: elvalue });
	}
	else if(id == 'txtusermail'){
	
	 this.setState({ email: elvalue });
	}
	
	else if(id == 'txtpassword'){
	
	 this.setState({ paswrd: elvalue });
	
	}
	else if(id == 'txtuserscode'){
	
	 this.setState({ scode: elvalue });
	
	}

	
	
   }

setuserlogin(e:any){

 if(this.state.ltypeguest == true){
	this.insertuserguest();
  }
  else{
    this.setlogintouser();
  }
  		
  e.preventDefault()
}
getuserloginpinbycode(e:any){
 const mailid = this.state.email;
 const code = this.state.scode;
 authuloged(mailid,code,'mailcd');

}
getuserloginpage(e:any){
loadwidgate('container',7);

}

setuserloginpin(e:any){
const hcode = Usersession.getCode();
 if(hcode !=""){
	
        const code = this.state.paswrd;
        if(isequal(hcode,code)){
        const ucd = gets('Userpin');
	 getmessage('Secured Pin is:',ucd);
	}
  }
  else{
    	let mailid = Usersession.getGuestmailid();

   	let usernm = null;
       if(gets('Username'))
	usernm = gets('Username');
        let nm = this.state.name;
        let userml = this.state.email;
        if(mailid.length > 2)mailid = mailid.substring(0,2);
         if(nm.length > 2)nm = nm.substring(0,2);
        if(usernm){ 
	if(usernm.length > 2)usernm = usernm.substring(0,2);
        }
        if(userml.length > 2)userml = userml.substring(0,2);

         

        if(isequal(usernm,nm) && isequal(mailid,userml) ){
        const ucd = gets('Userpin');
	 getmessage('Secured Pin is:',ucd);
  }
 }
  		
  e.preventDefault()
}

setlogintouser(){
 	
	this.loginauthouser();
	localStorage.setItem("ltype",'authorized');
}
setuserauthority(usrcode:any,usrtype: any,usrpoints:any,usroffer: any){
        
        const username = this.state.name;
        const usermail = this.state.email;
	const userinfo ={id:"NA",uname:username,utype: usrtype,upoints: usrpoints,offer:     	usroffer,ltype:'unauthorized',phone:"",mailid:usermail,mailvrfy:'0',phonevrify:'0'};
        const struserinfo = JSON.stringify(userinfo);
	localStorage.setItem("userinfo",struserinfo);
	localStorage.setItem("id","NA");
       
}
setlogininfo(usrallcodes:any){
	const arrcodes = usrallcodes.split(':');
        const usrcode = arrcodes[0];
        const usrpoints = arrcodes[1];
	
	const usroffer = arrcodes[2];
        const cod = usrcode;
        const utp = usrcode[0];
	Usersession.setUsertypeid(utp);
	
        const ucode = usrcode.substring(0,(usrcode.length -4));
	const usrtype = getusertype(utp);
	const uphone = arrcodes[3];
	
	const usrname = arrcodes[4];
        const ismailvrify = arrcodes[5];
	const isphonevrify = arrcodes[6];
	const usermail = this.state.email;
		
	const userinfo ={id:ucode,uname:usrname,utype: usrtype,upoints: usrpoints,offer: usroffer,ltype:'authorized',phone:uphone,mailid:usermail,mailvrfy:ismailvrify,phonevrify:isphonevrify};
        const struserinfo = JSON.stringify(userinfo);
	localStorage.setItem("userinfo",struserinfo);
       //alert(usrcode);
        localStorage.setItem("id",usrcode);
	//getmessage(usrcode,'');
	//localStorage.setItem("offerid",usroffer);
	//localStorage.setItem("points",usrpoints);
	//localStorage.setItem("utype",usrtype);
	//localStorage.setItem("ltype",'authorized');
	const citycode = ucode.substring(1,4);
	const ctid = cityidfromcod(citycode);
	Usersession.setCityId(ctid);
	
	
	
}

insertuserguest(){
	 try {
                let url = Configdata.srvurl + '/insertguestuser';
		if(this.iregctrlsvalidate('na')){
          	getmessage('On Process Please wait.....','');	
		const mailid = this.state.email;
		
                const response = axios.post(url, {
    		uname: this.state.name,
    		
    		uemail: mailid
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		 Usersession.setGuestmailid(mailid);
		getmessage(usercd,'');
		this.setuserauthority(usercd,'guest','0','0');
		const vld = clearform('frmlogin');
		//Usersession.setCityId("1");
		this.getdatasearch();
		
	        });		
              }
		
	   }
          }
        catch (exp:any) {
           // debugger;
		wrongmsg();
        }
}
loginauthouser(){
	 try {
	        let url = '';
		if(this.iregctrlsvalidate('na')){
          	getmessage('On Process Please wait.....','');	
		const mailid = this.state.email;
		if(this.state.mlorph == '')
		    return false; 		
		if(this.iregctrlsvalidate('autho')){
          	getmessage('On Process Please wait.....','');	

		//alert(this.state.mlorph);
		const userpaswrd = this.state.paswrd.trim();
		const usermail = this.state.email.trim();
                const response = axios.post(Configdata.srvurl + '/loginusertrasc', {
    		pass: userpaswrd,
    		mlph: this.state.mlorph,
    		uemail: usermail
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		//getmessage(usercd,'test');
		if(usercd == 'NA'){
		getmessage('Wrong mail id/phone or password','');
		}
		else{
		//getmessage(usercd,'');

		getmessage('Login successful','');
		this.setlogininfo(usercd);
		this.getdatasearch();
		}
		
		
	        });		
              }
	     }	
	   }
          }
        catch (ex:any) {
           // debugger;
		wrongmsg();
        }
}
gotosearchprpty(e:any){
        let criterias = Usersession.getSearchopts();
     
	//Usersession.setSearchopts(criterias);
	const homemain = document.getElementById('container') as HTMLElement;
      
	homemain.style.display = 'block';
	const Pdivc = document.getElementById('profilediv') as HTMLElement;
	if(Pdivc)
	Pdivc.style.display = 'none';
	if(homemain){
	unmountComponentAtNode(homemain);
	const srch = <Home />;
	ReactDOM.render(srch,homemain);	
	}
   }
	
getdatasearch(){

this.gotosearchprpty(0);
 }	
     closeprofilediv(){
	const Pdivr = document.getElementById('profilediv') as HTMLElement;
	Pdivr.style.display ='none';
     }

	render() {
		return (
		<form id="frmlogin">
			
                <div id="sinupsidebardiv" className="sidebar-search" style={{width:'65vw',top:'10vh',right:'20vw'}}>

		     <div className="search-title-bar">
                       	<div className="search-title">
			  Pin Recovery
			</div>
		     <a href="#" id="guestlogintype" onClick={e => this.closelogin(e)} title="close">

			<div style={{float:'right',marginRight:'10px'}} className="search-title">
			  X
			</div>
		   </a>	


	   	     </div>
		  <div id="selectlogintype" className="sidebar-scroll">
		   	
		     <div className="sidebar-basic-info" style={{width:'100%',display:'none'}}>
		       <div> 
			<a href="#" id="guestlogintype" onClick={e => this.typeselect(e)} title="Guest">

                       	<div className="searchtype" id="loginguestdiv" >
			  Guest	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="authorized">

			<div className="searchtype" id="loginuserdiv" style={{backgroundColor:'green'}}>
			  Authoriz	
			</div>
			</a>
		     </div>
		    </div>
		   <div className="sidebar-basic-info" id="unamediv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginusername" style={{width:'94%'}}>
			  <input placeholder="Enter secure code"  onChange={e => this.textboxChange(e)} id="txtuserscode" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>

		   <div className="sidebar-basic-info" id="uemailodiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div id="recoverypass">	
			 <div className="searchtype" id="loginuseremail" style={{width:'94%'}}>
			  <input placeholder="Enter emailId"  onChange={e => this.textboxChange(e)} id="txtusermail" type="text" style={{width:'90%'}}/>
	
			 </div>
 			 <div className="searchtype" id="recoveryname" style={{width:'94%',display:'none'}}>
			  <input placeholder="Enter user name starting three letter"  onChange={e => this.textboxChange(e)} id="txtusername" type="text" style={{width:'90%'}}/>
	
			 </div>
		       </div>
		    </div>
		     <div className="sidebar-basic-info" id="upassdiv" style={{width:'90%',marginTop:'1vh'}}>
		       <div>	
			 <div className="searchtype" id="userpassworddiv" style={{width:'94%'}}>
 <input placeholder="Enter Secured code"  onChange={e => this.textboxChange(e)} id="txtpassword" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
	
		   
		   	
		     <div className="sidebar-basic-info" style={{width:'100%' ,marginTop:'5vh',height:'60px'}}>
		       <div> 
			

                       	<div id="pinrecovery" className="pinrecoverydv">
	   			<a href="#" onClick={e => this.getuserloginpinbycode(e)} title="show pin">

			<div className="searchtype" id="usersignin" style={{width:'auto',float:'right',height:'auto',position:'relative',right:'12%'}}>
			  Show Pin	
			</div>
     
			</a>
                      <a href="#" className="blanka" onClick={e => this.getuserloginpage(e)} title=" Forgot Code">

			<div id="usersignin" style={{width:'auto',float:'left',height:'auto',position:'relative',left:'12%'}}>
			  Forgot Code	
			</div>
     
			</a>

			</div>
			
			

		     </div>
		    </div>

 		   


		 </div>
	      </div>

		

		</form>
		);
	}

	
}

export default Registerpin;
